import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SigntrustCertificate } from '@models/index.model';
import { environment } from '@environments/environment';

@Component({
    selector: 'lib-dialog-sign-cert-view-details',
    templateUrl: './dialog-sign-cert-view-details.component.html',
    styleUrls: ['./dialog-sign-cert-view-details.component.scss'],
    standalone: false
})
export class DialogSignCertViewDetailsComponent implements OnInit {
  public isMobile: boolean;
  public certificate: SigntrustCertificate;
  public currentLang: string;

  constructor(public dialogRef: MatDialogRef<DialogSignCertViewDetailsComponent>, @Inject(MAT_DIALOG_DATA) public data, private _translate: TranslateService) {
    this.isMobile = environment.platform === 'mobile';
  }

  ngOnInit(): void {
    this.currentLang = this._translate.currentLang;
    this.certificate = this.data.certificate;
  }
}
